module.exports = __webpack_public_path__ + "static/media/disc-harrow.7459273e.svg";